const initialState = {
    isOpened: false,
    id: null,
};

const ACTION_KEY = 'DELETE_MODAL';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case `${ACTION_KEY}_OPEN`: {
            return {
                ...state,
                id: action.payload,
                isOpened: true,
            };
        }
        case `${ACTION_KEY}_CLOSE`: {
            return {
                ...state,
                id: null,
                isOpened: false,
            };
        }
        default:
            return state;
    }
};

export default reducer;
